import { render, staticRenderFns } from "./roleInfoModal.vue?vue&type=template&id=02a4a98b"
import script from "./roleInfoModal.vue?vue&type=script&lang=js"
export * from "./roleInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports